/**
 * Components that shows list of videos that the particular listing has
 */
import { computed, defineComponent, provide, ref, } from "vue";
import { AppGeneralVariables } from 'src/plugins/general/variables';
import { AppStringMethods } from 'src/plugins/string/stringMethods';
import { QueryVideoPlugin } from 'src/features/listing/components/video/methods/queryVideo';
import generalDialog from "src/components/general/dialog.vue";
import lazyLoad from "src/components/image/lazyLoad.vue";
export default defineComponent({
    name: "listing-video",
    props: {
        userType: {
            type: String,
            default: 'user'
        },
        listingId: {
            type: String,
            required: true,
        },
        appType: {
            type: String,
            default: 'getspaces'
        }
    },
    components: {
        lazyLoad,
        generalDialog,
    },
    emits: ["show-video"],
    setup(props, context) {
        provide("routeDisabled", ref(false));
        const { styleType } = AppGeneralVariables();
        const { parseCamelCase } = AppStringMethods();
        const videoListDialogShow = ref(false);
        const videoList = ref([]);
        function hideVideoList() {
            videoListDialogShow.value = false;
        }
        function showVideo(data) {
            context.emit("show-video", data);
        }
        /**
         * Query backend for list of videos of the listing
         */
        function showVideoListClick() {
            if (videoList.value.length > 0) {
                videoListDialogShow.value = true;
            }
            showVideo$.next("");
        }
        const toLoad = computed(() => videoList.value.length === 0);
        function videoCallback(data) {
            videoList.value = data;
            videoListDialogShow.value = true;
        }
        const { showVideo$ } = QueryVideoPlugin(props.appType, props.userType, props.listingId, toLoad, videoCallback);
        return {
            styleType,
            parseCamelCase,
            hideVideoList,
            showVideoListClick,
            showVideo,
            videoList,
            videoListDialogShow
        };
    },
});
